module.exports = __webpack_public_path__ + "img/视频精品.b7a65cb0.jpg";